export function startCase(value: any) {
  if (!value) {
    return ''
  }
  return typeof value === 'string'
    ? value
        .toLowerCase()
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (l) => l.toUpperCase())
    : value
}
